import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

function ProductListingGridPriceBlock(props) {
  function getPastAmountBlockForComboKit() {
    let block = '';

    if (props.price.mainProductWasPrice && props.price.mainProductCurrentPrice) {
      block += `${props.translations.mainProductWasPriceTranslation} ` +
        `${props.price.mainProductWasPrice}, ` +
        `${props.translations.mainProductCurrentPriceTranslation} ` +
        `${props.price.mainProductCurrentPrice}.`;
    }

    if (props.price.separateSellingPrice) {
      block += `${block ? '\n' : ''}${props.translations.separateSellingPriceTranslation} ` +
        `${props.price.separateSellingPrice}`;
    }

    return block;
  }

  function getPastAmountBlockForNormalProduct() {
    return props.price.wasPrice
      ? (
        <strong>
          {props.translations.wasPriceTranslation} {props.price.wasPrice}
        </strong>
      )
      : '';
  }


  return (
    <div
      className="productPrices border-t border-b"
      style={props.productPricesHeight ? { height: props.productPricesHeight } : undefined}
    >
      <div className={`amounts space-b ${props.isOutOfStock ? 'prd-oos' : ''}`}>
        <div className="main-amount center">
          {props.isFlashSale &&
            <Fragment>
              <strong>{props.translations.webExclusivePriceTranslation}</strong>
              <br />
            </Fragment>
          }
          <strong
            className={props.price.perMonthPrice ? 'tariff-price' : 'price'}
            data-product="price"
          >
            {' '}{props.price.perMonthPrice
              ? props.price.perMonthPrice
              : props.price.price
            }{' '}
          </strong>
          {props.price.perMonthPrice &&
            <span className="per-month">
              <strong>{props.translations.perMonthTranslation}</strong>
            </span>
          }
          <span className="past-amount">
            {props.isComboKit
              ? getPastAmountBlockForComboKit()
              : getPastAmountBlockForNormalProduct()
            }
          </span>
          {props.price.savingsPrice &&
            <strong className="saving">
              &nbsp;{props.translations.savingsPriceTranslation} {props.price.savingsPrice}
            </strong>
          }
          {props.price.inStorePrice &&
            <p>
              {props.translations.inStorePriceTranslation} {props.price.inStorePrice}
            </p>
          }
        </div>
      </div>
    </div>
  );
}

ProductListingGridPriceBlock.displayName = 'ProductListingGridPriceBlock';

ProductListingGridPriceBlock.propTypes = {
  isComboKit: PropTypes.bool.isRequired,
  isFlashSale: PropTypes.bool.isRequired,
  isOutOfStock: PropTypes.bool.isRequired,
  price: PropTypes.shape({
    price: PropTypes.string.isRequired,
    mainProductWasPrice: PropTypes.string,
    mainProductCurrentPrice: PropTypes.string,
    separateSellingPrice: PropTypes.string,
    wasPrice: PropTypes.string,
    savingsPrice: PropTypes.string,
    inStorePrice: PropTypes.string,
    perMonthPrice: PropTypes.string
  }).isRequired,
  translations: PropTypes.shape({
    mainProductWasPriceTranslation: PropTypes.string.isRequired,
    mainProductCurrentPriceTranslation: PropTypes.string.isRequired,
    separateSellingPriceTranslation: PropTypes.string.isRequired,
    wasPriceTranslation: PropTypes.string.isRequired,
    savingsPriceTranslation: PropTypes.string.isRequired,
    inStorePriceTranslation: PropTypes.string.isRequired,
    webExclusivePriceTranslation: PropTypes.string.isRequired,
    perMonthTranslation: PropTypes.string.isRequired
  }).isRequired,
  productPricesHeight: PropTypes.number
};

ProductListingGridPriceBlock.defaultProps = {
  productPricesHeight: undefined
};

export default ProductListingGridPriceBlock;
